import { useEffect, useMemo, useState } from 'react';
import { useTranslate } from '../../customHooks';
import { withRouter } from 'react-router-dom';
import { Table } from '../../components/PANWDSElements';
import { ColumnOptions } from "@panwds/react-table";
import { useGetRulesByRuleStackQuery } from '../../redux/services/rules-service';
import { TruncateText } from '@panwds/react-ui';
import { actionMapping, buidConstratints, flatPropertiesAndArrayValue } from './rulesUtils';

const GlobalRulesList = (props: Record<string, any>) => {
  const translate = useTranslate();
  const [preNextToken, setPreNextToken] = useState<string | undefined | null>(null);
  const [postNextToken, setPostNextToken] = useState<string | undefined | null>(null);
  const [localRulesList, setLocalRulesList] = useState<any[]>([]);
  const RuleStackName = props.RuleStackName;
  const Region = props?.Region;

  const { data: preRules, error: preRuleFetchError, isFetching: preRulesFetching } = useGetRulesByRuleStackQuery({
    RuleListName: "PreRule", RuleStackName, NextToken: preNextToken,
    Describe: true, MaxResults: 50, Region
  }, {
    skip: preNextToken === undefined || ! RuleStackName, // Skip the initial query if no nexttoken is provided
  });

  const { data: postRules, error: postRuleFetchError, isFetching: postRulesFetching } = useGetRulesByRuleStackQuery({
    RuleListName: "PostRule", RuleStackName, NextToken: postNextToken,
    Describe: true, MaxResults: 50, Region
  }, {
    skip: postNextToken === undefined || ! RuleStackName, // Skip the initial query if no nexttoken is provided
  });;

  if (preRuleFetchError) {
    toast.error(preRuleFetchError?.error, {toastId: "global-rules-desribe"});
  }

  if (preRuleFetchError) {
    toast.error(preRuleFetchError?.error, {toastId: "global-rules-desribe"});
  }

  useEffect(() => {
    if (preRules && preRules.ruleEntries) {
      setLocalRulesList((prevItems) => [...prevItems, ...preRules.ruleEntries]);
      setPreNextToken(preRules.nextToken);
    }
  }, [preRules]);

  useEffect(() => {
    if (postRules && postRules.ruleEntries) {
      setLocalRulesList((prevItems) => [...prevItems, ...postRules.ruleEntries]);
      setPostNextToken(postRules.nextToken);
    }
  }, [postRules]);

  const columns = useMemo<ColumnOptions<any>[]>(
    () => [
    {
      accessor: 'Priority',
      Header: translate(`resources.rules.fields.Priority`),
      maxWidth: 100,
    },
    {
      accessor: 'Rule.RuleName',
      Header: translate(`resources.rules.fields.RuleName`),
    },
    {
      accessor: 'Rule.Enabled',
      Header: translate(`resources.rules.fields.Enabled`),
      maxWidth: 100,
      Cell: ({ value }: { value: string }) => <>{(value) ? translate('generic.yes') : translate('generic.no')}</>,
    },
    {
      accessor: 'Rule.Source',
      Header: translate(`resources.rules.fields.Source`),
      Cell: ({ value }: { value: string }) => <TruncateText>{flatPropertiesAndArrayValue(value)}</TruncateText>,
    },
    {
      accessor: 'Rule.Destination',
      Header: translate(`resources.rules.fields.Destination`),
      Cell: ({ value }: { value: string }) => <TruncateText>{flatPropertiesAndArrayValue(value)}</TruncateText>,
    },
    {
      accessor: 'Rule.Action',
      Header: translate(`resources.rules.fields.Action`),
      Cell: ({ value }: { value: string }) => <>{actionMapping[value as keyof typeof actionMapping] || value}</>,
    },
    {
      accessor: 'Rule.Constraints',
      Header: translate(`resources.rules.fields.Constraints`),
      Cell: ({ row }: Record<string, any>) => <TruncateText>{buidConstratints(row?.original)}</TruncateText>,
    },
    {
      accessor: 'Rule.Logging',
      Header: translate(`resources.rules.fields.Logging`),
      maxWidth: 100,
      Cell: ({ value }: { value: string }) => <>{(value) ? translate('generic.yes') : translate('generic.no')}</>,
    },
    {
    accessor: 'Rule.DecryptionRuleType',
    Header: translate(`resources.rules.fields.DecryptionRuleType`),
    },
    {
      accessor: 'RuleListName',
    },
  ],
  []
);

return (
  <>
    <Table
      tableComponentData={localRulesList || []}
      tableComponentColumns={columns}
      tableComponentEmptyStateProps={{
        heading: translate('resources.rules.fields.EmptyTitle'),
      }}
      tableComponentFilterBar={{
        hideAddFilter: true,
        filterConfig: undefined,
      }}
      tableBatchAction={undefined}
      tableIsLoading={preRulesFetching || postRulesFetching}
      tableisBackgroundFetching={undefined}
      tableTitle={translate(`resources.rules.name`)}
      tableInitialGroupBy={['RuleListName']}
      tableOffsetHeight={250}
    />
  </>
);
}

export default withRouter(GlobalRulesList);
